import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button';
import MaxWidthContainer from '../../../../components/MaxWidthContainer';
import PageSectionTitle from '../../../../components/PageSectionTitle';
import Title from '../../../../components/Title';

import './CoursePicker.scss';

const CoursePicker = ({ title, description, btnText, onBtnClick }) => {
  const className = 'c-HomePageContainer-CoursePicker';

  return (
    <div className={className}>
      <MaxWidthContainer>
        <div className={`${className}__wrapper`}>
          <Title text={title} />
          <div className={`${className}__content`}>
            <PageSectionTitle title={description} />
            <Button displayType="primary" onClick={onBtnClick}>
              {btnText}
            </Button>
          </div>
        </div>
      </MaxWidthContainer>
    </div>
  );
};

CoursePicker.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  btnText: PropTypes.string,
  onBtnClick: PropTypes.func,
};

export default CoursePicker;
